import { Node, NodeProps } from "@xyflow/react";
import { DefaultNodeData } from "@zapier/canvas-state";

import { AssetNodeSkeleton } from "../AssetNodeSkeleton";

export function InterfaceNode(props: NodeProps<Node<DefaultNodeData>>) {
  const { id, data, selected } = props;
  return (
    <AssetNodeSkeleton
      id={id}
      isSelected={selected}
      label={data.label}
      type="interface"
      placeholder="Enter Interface title"
    />
  );
}
